import { Image, StyleSheet, Text, View } from 'react-native';
import type { ImageSourcePropType } from 'react-native';

import { colors } from '../theme';
import { inter400, inter500, isWeb } from '../utils/platform';

export type SkillCardProps = {
  title: string;
  description: string;
  icon: ImageSourcePropType;
};

export function SkillCard({ title, description, icon }: SkillCardProps) {
  return (
    <View style={styles.card}>
      <View style={styles.iconFrame}>
        <Image source={icon} style={styles.icon} resizeMode="contain" />
      </View>
      <View style={styles.textCol}>
        <View style={styles.titleRow}>
          <Text style={styles.title}>{title}</Text>
        </View>

        <Text style={styles.description}>{description}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 12,
    overflow: 'visible',
    padding: 0,
    textDecorationLine: 'none',
    width: '100%',

    ...(isWeb
      ? {
          cursor: 'pointer',
        }
      : null),
  },
  iconFrame: {
    borderColor: colors.surface,
    borderRadius: 8,
    borderWidth: 1,
    overflow: 'hidden',
    padding: 8,
  },
  icon: {
    height: 30,
    width: 30,
  },
  textCol: {
    flex: 1,
    gap: 4,
    overflow: 'hidden',
  },
  titleRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
    overflow: 'hidden',
  },
  title: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19.2,
  },
  arrowBox: {
    alignItems: 'center',
    height: 18,
    justifyContent: 'center',
    width: 18,
  },
  description: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 19.6,
  },
});
